import { useOpenStatus, fmtTime } from "@/lib/hours";

export function OpenStatus({ loc, compact = false }) {
  const st = useOpenStatus(loc.hours);
  const color = st.open ? "#22C55E" : "#EF4444";
  const detail = st.open
    ? `until ${fmtTime(st.until)}`
    : st.opensAt ? `opens ${st.opensDay === "today" ? "" : st.opensDay + " "}${fmtTime(st.opensAt)}` : "";
  return (
    <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-black/50 px-3 py-1 font-mono-ui text-[11px] font-bold uppercase tracking-wider text-white"
      data-testid={`open-status-${loc.id}`} data-open={st.open ? "true" : "false"}>
      <span className="pulse-dot h-2 w-2 rounded-full" style={{ background: color, color }} />
      {compact && <span className="text-white/60">{loc.name}</span>}
      <span style={{ color }}>{st.open ? "Open Now" : "Closed"}</span>
      {detail && <span className="normal-case tracking-normal text-white/60">· {detail}</span>}
    </span>
  );
}
